import React from "react";

import {
  gaEvent,
  virtualPageView,
} from "../../shared/helpers/gtm_tracking";

function trackSelectOffer(label) {
  gaEvent("Last Minute Page", "Package", label);
  virtualPageView("BOOKING_CUSTOMIZE_OFFER");
}

const instantBook = () => (
  <span className="venue__offer--instant-book">
    <i className="fas fa-rabbit-fast"></i>
    <span>Instant book</span>
  </span>
);

class SelectOffer extends React.Component {
  _selectOffer = () => {
    const { label, selectOffer } = this.props;

    trackSelectOffer(label);
    selectOffer();
  };

  render() {
    const self = this;

    return (
      <div className="venue__offer__ctas">
        {self.props.isVenuePage && instantBook()}
        <i className="fa fa-angle-right fa-fw"></i>
        <span
          className="venue__offer__cta venue__offer__cta--toggle button button--primary--solid button--pointer"
          onClick={self._selectOffer}
        >
          {self.props.label}
        </span>
      </div>
    );
  }
}

export default SelectOffer;



// WEBPACK FOOTER //
// ./components/last_minute_deals/SelectOffer.js